import { Input } from "antd";
import React, { useMemo, useState } from 'react';
import { useSelector } from "react-redux";
import { openPopup2 } from "../../../contexts/PopupContext";
import { ELEMENT_ID, IPropsElement } from '../../../pages/ChecklistPage/PopupEdit/constants';
import { selectRoles, selectTenantId } from "../../../util/store/selectors";
import { getStore } from "../../../util/store/store";
import { patternEmail, USER_ROLE, userRole } from "../../../util/varibles/constants";
import Footer from "../../Popup/_components/Footer";
import { getChecklist, useChecklist } from "../ChecklistContext";
import styles from '../style.module.scss';

const PopupSign: React.FC<{ name?: string, onSave(note: string): void, onClose?(): void }> = ({
    name,
    onSave,
    onClose
}) => {
    const [note, setNote] = useState("");

    const handleSave = () => {
        onSave(note)
        onClose?.()
    }

    return <div>
        <div className='mb-1'>
            Do you want to sign on <span className='font-[600]'>{name}</span> checklist?
        </div>
        <Input placeholder="Note for the signature" value={note} onChange={({ target }) => setNote(target.value || "")} />
        <Footer ok={{ text: 'Sign', click: handleSave }} cancel={{ click: onClose }} />
    </div>
}


const Sign: React.FC<{ data: any, roles: any }> = ({ data, roles }) => {
    const [note = {}, set] = useChecklist(state => state.result[ELEMENT_ID.SIGN]);
    const [signer = {}] = useChecklist(state => state.data?.signer);
    const roleId = data.value;
    const isChecked = signer[roleId] !== undefined;
    const get = getChecklist();
    const isPermission = roles[roleId] && !get().disabled;
    const { name = null } = userRole[roleId] || {};

    const signedName = useMemo(() => {
        const { [roleId]: signedName = "" } = signer || {};
        const reg = new RegExp(patternEmail);
        return reg.test(signedName) ? <>: <div className="font-[600] mx-1">{signedName}</div> signed</> : ""
    }, [roleId, signer])

    if (!name)
        return null;

    const handleSigh = (isChecked: boolean) => {
        if (isChecked)
            return;
        const { name } = get().data || {};
        const { username } = getStore().login.user;
        openPopup2(<PopupSign
            name={name}
            onSave={(note: string) => {
                set(({ data: prevData, result: prevResult }) => {
                    return {
                        data: prevData ? { ...prevData, signer: { ...prevData?.signer || {}, [roleId]: username } } : prevData,
                        result: { ...prevResult, [ELEMENT_ID.SIGN]: { ...prevResult[ELEMENT_ID.SIGN] || {}, [roleId]: note } }
                    }
                })
            }}
        />, { modalProps: { title: "Confirm on signature", zIndex: 1032 } })
    }

    return <div className={styles.signElement} key={roleId}>
        <div className={styles.label}>
            <div className="truncate whitespace-nowrap flex">{name}'s signature{signedName}</div>
        </div>
        <div className={styles.sign}>
            {isPermission
                ? <div className={styles.btSign} onClick={() => handleSigh(isChecked)}
                    data-is-check={isChecked}>
                    {isChecked ? 'Signed' : 'Tap to sign'}
                </div>
                : <div className={styles.btWait} data-is-check={isChecked}>
                    {isChecked ? 'Signed' : 'Waiting to be signed'}
                </div>}
            {note[roleId] && <span title={note[roleId]}>{`Note: ${note[roleId]} `}</span>}
        </div>
    </div>
}

const SignElement: React.FC<IPropsElement> = (props) => {
    const { options = '' } = props.properties;
    const roles = useSelector(selectRoles);
    const tenantId = useSelector(selectTenantId);
    const [vesselTenantId] = useChecklist(state => state.vesselTenantId);
    const permission = useMemo(() => {
        const isSuper = roles.indexOf(USER_ROLE.SUPER_ADMIN) !== -1;
        return isSuper
            ? Object.keys(userRole).reduce((rs: Record<string, boolean>, key) => {
                rs[key] = true;
                return rs;
            }, {})
            : roles.reduce((rs: Record<string, boolean>, key: string) => {
                if (key === USER_ROLE.ADMIN) {
                    rs[USER_ROLE.CUSTOMER] = true;
                    if (tenantId && vesselTenantId && `${tenantId}` === `${vesselTenantId}`)
                        rs[USER_ROLE.CREW] = true;
                } else
                    rs[key] = true;
                return rs;
            }, {});
    }, [roles, tenantId, vesselTenantId])

    const data = useMemo(() => {
        try {
            if (typeof options === 'object')
                return options;
            return JSON.parse(options)
        } catch (error) {
            console.log('JSON error: ', error);
            return []
        }
    }, [options]);

    return <>
        {data.map((item: any, i: number) => <Sign key={i} data={item} roles={permission} />)}
    </>
};

export default SignElement;
